exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ToastArea[data-v-4ca3e2b9],\n.ToastAreaHen[data-v-4ca3e2b9] {\n  padding: 2vw 3vw;\n  box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.1);\n  border-radius: 1vh;\n  max-width: 66vw;\n}\n.ToastAreaHen[data-v-4ca3e2b9] {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n", ""]);

// exports
